import user from './user'
export default {
    user
}



// WEBPACK FOOTER //
// ./src/store/modules/index.js